module.exports = __webpack_public_path__ + "img/31.9a0be677.jpg";